import { enqueueSnackbar } from 'notistack';

/**
 * Gera o conteúdo HTML para o iframe.
 */
const getSrcDot = (html: string, title = '') => {
    return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>${title}</title>
            <style>
                * {
                    box-sizing: border-box;
                }

                html, body {
                    margin: 0;
                    padding: 0;
                }

                body {
                    font-family: Roboto, Helvetica, Arial, sans-serif;
                    line-height: 1.5;
                }

                @page {
                    margin: 0;
                }
                
                @media print {
                    * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                }
            </style>
        </head>
        <body>
            ${html}
        </body>
        </html>
    `;
};

/**
 * Gera uma página para imprimir/salvar PDF de acordo com o conteúdo HTML passado.
 */
export const downloadHtmlAsPdf = (html: string, title = '') => {
    const iframe = document.createElement('iframe');

    iframe.style.display = 'none';

    document.body.appendChild(iframe);

    iframe.srcdoc = getSrcDot(html, title);

    iframe.onload = () => {
        try {
            iframe.contentWindow?.print();
        } catch (e) {
            enqueueSnackbar('Falha ao gerar o PDF', { variant: 'error' });
        } finally {
            setTimeout(() => document.body.removeChild(iframe), 1000);
        }
    };

    iframe.onerror = () => {
        enqueueSnackbar('Falha ao gerar o PDF', { variant: 'error' });

        setTimeout(() => document.body.removeChild(iframe), 1000);
    };
};
